import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, signal } from '@angular/core';

import { MaterialDisabledActionDirective } from '../../../directives/material-disabled-action.directive';

@Component({
    selector: 'ecm-mat-inline-suggestion',
    templateUrl: 'material-inline-suggestion.html',
    standalone: true,
    imports: [MaterialDisabledActionDirective, CommonModule],
})
export class MaterialInlineSuggestionComponent implements OnInit {
    /**
     * Suggestion icon
     * @type {string} itemIcon
     */
    @Input() public icon?: string;

    /**
     * Suggestion style
     * @type {priority1 | priority2 }
     */
    @Input() public style: 'priority1' | 'priority2';

    /**
     * Suggestion title
     * @type {string}
     */
    @Input() public title: string;

    /**
     * Suggestion paragraph to display
     * @type {string? | string[]?} text
     */
    @Input() public set text(textToDisplay: string | string[]) {
        if (!textToDisplay) {
            this.displayedText.set(null);
            return;
        }
        if (typeof textToDisplay === 'string') {
            this.displayedText.set([textToDisplay]);
            return;
        }
        this.displayedText.set(textToDisplay as string[]);
    }
    public displayedText = signal<string[]>(null);

    /**
     * Suggestion action style
     * @type {"button" | "link"}
     */
    @Input() public confirmationStyle?: 'button' | 'link' = 'button';

    /**
     * Suggestion confirmation label
     * @type {string}
     */
    @Input() public confirmationLabel?: string;

    /**
     * Suggestion confirmation path
     * @type {string}
     */
    @Input() public confirmationPath?: string;
    @Input() public isExternalUrl?: boolean;

    /**
     * Suggestion data-e2e tag
     * @type {string?}
     */
    @Input() public e2e?: string;

    /**
     * Is disabled for eclair
     * @param {boolean} [isDisabledEclair=false]
     */
    @Input() public isDisabledEclair = false;

    /**
     * Event emitter
     */
    @Output() public materialSuggestEvent: EventEmitter<any> = new EventEmitter<any>();

    /**
     * Suggestion btnStyle
     * @type {btn-secondary | btn-primary }
     */
    @Input() public btnStyle: 'btn-secondary' | 'btn-primary' = 'btn-secondary';

    /**
     * @inheritDoc
     */
    public ngOnInit(): void {
        this.e2e = (this.e2e || 'e2e-material-suggest').concat('-', this.style);
    }

    /**
     * Emit event on alert confirm
     */
    public materialSuggestConfirm(): void {
        this.materialSuggestEvent.emit();
    }

    /**
     * Is confirmation style link
     * @returns {boolean}
     */
    public isLinkConfirmationTemplate(): boolean {
        return this.confirmationStyle === 'link' || (this.confirmationStyle === 'button' && !!this.confirmationPath);
    }
}
